import { Navigate, Outlet } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { selectIsAuthenticated, setUser } from "../store/features/userSlice";
import { useEffect, useLayoutEffect } from "react";
import { getAuth } from "../lib/utils";

const AuthMiddleware = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useLayoutEffect(() => {
    // Check localStorage on component mount
    const storedAuth = getAuth();
    if (storedAuth && !isAuthenticated) {
      // If we have stored auth data but not in Redux, restore it
      dispatch(setUser(storedAuth));
    }
  }, [dispatch, isAuthenticated]);

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render the protected route
  return <Outlet />;
};

export default AuthMiddleware; 